import { useState, type ReactNode } from "react";
import { cn } from "@/lib/cn";
import { Sidebar } from "./Sidebar";
import { TopNav } from "./TopNav";
import styles from "./shell.module.css";

export interface GlobalLayoutProps {
  children: ReactNode;
  breadcrumbs?: ReactNode;
}

/** Persistent HQ application shell (sidebar + top nav + content). */
export function GlobalLayout({ children, breadcrumbs }: GlobalLayoutProps) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className={cn(styles.shell, collapsed && styles.shellCollapsed)}>
      <Sidebar collapsed={collapsed} />
      <TopNav onToggleSidebar={() => setCollapsed((value) => !value)} />
      <div className={styles.main}>
        {breadcrumbs}
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
}
